import { Policy } from '../Policy';
import { PetParent } from './PetParent';
import { PetGender } from '../../values/PetGender';
export class Pet {
    public readonly key: string;
    public readonly name: string;
    public readonly breed: string;
    public readonly gender: PetGender;
    public readonly birthDate: Date | undefined;
    public readonly chip: string;
    public readonly petParent: PetParent | undefined;
    public readonly policies: Policy[];
    public readonly photo: string | undefined;

    constructor({
        key,
        name,
        breed,
        gender,
        birthDate,
        chip,
        petParent,
        policies,
        photo,
    }: {
        key: string;
        name: string;
        breed: string;
        gender: PetGender;
        birthDate: Date | undefined;
        chip: string;
        petParent?: PetParent;
        policies: Policy[];
        photo?: string;
    }) {
        this.key = key;
        this.name = name;
        this.breed = breed;
        this.gender = gender;
        this.birthDate = birthDate;
        this.chip = chip;
        this.petParent = petParent;
        this.policies = policies;
        this.photo = photo;
    }

    getPolicyByIdentifier(identifier: string) {
        const result = this.policies.find((policy) => policy.identifier === identifier);
        if (result == null) {
            throw Error(`Policy with identifier ${identifier} not found`);
        }
        return result;
    }

    get totalClaimRequestCount(): number {
        return this.policies.map((policy) => policy.claimRequestStats?.totalClaimRequestCount ?? 0).reduce((a, b) => a + b, 0) ?? 0;
    }

    get openClaimRequestCount(): number {
        return this.policies.map((policy) => policy.claimRequestStats?.openClaimRequestCount ?? 0).reduce((a, b) => a + b, 0) ?? 0;
    }
}
